<template>
<div class="shopify-settings">

		<div class="brdr_box_w_checkbox layout-column">
			<div>
				<input-field  class="right w100 form-group with-copy-icon with_top_block"
				              placeholder="eg. yourstore.myshopify.com"
				              label="Your store domain name"
				              @input="storeNameChanged"
				              :disabled="!!config.token"
				              v-model="config.store_url" />
			</div>

			<connect-service :attributes="attributes" :config="configData" >
				<template v-slot:connect>
					<div v-if="attributes.name==='google_sheets'" :class="{'disabled':connecting}"
					     class="google-connect-btn" @click.prevent="connectToService()">
					</div>
					<template v-else >
						<v-button label="Connect" :loading="connecting" @click.prevent="connectToService()" />
						<div class="margin-b-10">
							<div class="or-wrapper">
								<h2>Or</h2>
								<div class="line"></div>
							</div>

							<v-button flat :right-icon="require('@/assets/img/arrow-right.svg')"
							          is-link label="Connect using a custom app..." @click="openCustomApp=true" />
						</div>
					</template>
				</template>
				<template v-slot:disconnect>
					<v-button red border label="Disconnect" :loading="connecting" @click.prevent="disconnectFromService()" />
				</template>
			</connect-service>

				<v-switch label="Send receipt emails?" :value="!!config.no_receipts"
				          v-model="config.no_receipts" :false-value="true" :true-value="false">
					<template v-slot:description>
						When enabled Funnelish will trigger the default order confirmation/receipt
						email from within your Shopify store.
						This feature fully supports bundled orders.
					</template>
				</v-switch>
		</div>

	<popup-backdrop v-if="openCustomApp" @close="openCustomApp=false">
		<shopify-settings-custom-app :level="1" :attributes="attributes" :redirect-shop-name="redirectShopName"
		 :is-shopify-redirect="isShopifyRedirect" :config="config" :config-data="configData"
			@close="openCustomApp=false" @done="done($event)" />
	</popup-backdrop>
</div>
</template>

<script>
import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
import ConnectService from "@/components/popup-details-parts/connect-service";
import VButton from "@/components/base/v-button";
import API from "@/api";
import ShopifySettingsCustomApp from "@/views/integrations/shopify-settings-custom-app";
import PopupBackdrop from "@/components/base/popup-backdrop";
export default {
	name: "shopify-settings", components: {
		PopupBackdrop,
		ShopifySettingsCustomApp, VButton, ConnectService, VSwitch, InputField},
	mixins: [API],
	props:['config','attributes','configData','isShopifyRedirect','redirectShopName'],
	data() {
		return {
			openCustomApp: false,
			connecting: false,
		}
	},
	computed:{
	},
	methods: {
		storeNameChanged(v) {
			v = v.replace("https://", "").replace("/", "")
			this.config.store_url = v;
		},
		done() {
			this.openCustomApp=false;
			this.$emit('reload');
		},
		async connectToService() {
			try {
				this.connecting = true;

				// https://app.funnelish.com/api/v1/integration-handlers/shopify-install
				if (this.isShopifyRedirect) {
					let host = window.location.host;
					if (host.includes("localhost") || host.includes("beta.funnelish.com")) {
						if (host.includes("localhost")) host = 'localhost:8000';

						let installUrl = `${window.location.protocol}//${host}/api/v1/integration-handlers/shopify-connect`

						delete this.$route.query['integration-redirect'];
						let query = JSON.parse(JSON.stringify(this.$route.query))
						query['token'] = this.$store.state.token;

						window.location = installUrl + '?' + Object.keys(query)
								.map(key => {
									return (encodeURIComponent(key) + '=' + encodeURIComponent(query[key]))
								})
								.join('&');
						return
					}
				}

				let result = await this.api.integrations.connect(this.attributes.name, {arg1: this.config.store_url})
				if (result.success) {
					window.location.replace(result.result);
				}
			} catch (e) {
				this.connecting = false;
				console.error("error:", e);
			} finally {
			}
		},
		async disconnectFromService() {
			try {
				this.connecting = true;
				let result = await this.api.integrations.disconnect(this.attributes.name, {
					arg1: '', arg2: "", id: 0
				});
				if (result.success) {
					this.$emit('reload');
				}
			} catch (e) {
				console.error("error:", e)
			} finally {
				this.connecting = false;
			}
		},
	},
	mounted() {
	}
}
</script>

<style lang="scss" scoped>
.shopify-settings {
	.or-wrapper {
		height: 35px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-bottom: 10px;
		margin-top: 10px;
		h2 {
			font-size: 16px;
			margin-bottom: 0;
			background-color: #f7f9fd;
			padding: 0 1rem;
			position: absolute;
			text-transform: uppercase;
		}
		.line {
			width: 100%;
			height: 1px;
			background-color: #e6e8ea;
		}
	}
}
</style>
